module.exports = __webpack_public_path__ + "static/screenshot_03@2x-ff1d26cd7ce9922cfd09875fe7d452e0.png";